var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "ce-wrapper" }, [
        _c("div", {
          staticClass: "ce-text ce-bodytext",
          domProps: {
            innerHTML: _vm._s(_vm.$t("mediaGallery.terms.conditions")),
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "media-gallery__terms__actions" },
          [
            _c("global-button", { on: { click: _vm.accept } }, [
              _vm._v(_vm._s(_vm.$t("mediaGallery.terms.button"))),
            ]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }